<template>
  <div class="addEmployeeVue" v-loading="initialLoading">
    <div v-if="job">
        <div class="o-main-content-area">
        <!-- Heading Section -->
        <div class="row c-responsive-fixwidth">
            <div class="col-md-6">
                <h1 class="h1">Add Call: <span id="add-call" @click="navigateToJobDetails" class="header-hyper-link">{{ job.title }}</span></h1>
            </div>
            <div class="col-md-6 text-right">
                <ul class="o-filter-area">
                    <li><a href="javascript: void(0)" @click="$router.go(-1)" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a></li>
                </ul>
            </div>
        </div>
        <!-- /Heading Section -->
        <!-- Main Body Content area -->
    

        </div>
            <!-- Tab nav area -->
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">
                <div class="row">
                    <div class="col col-sm-3">
                        <div class="skill-listing-left o-left-box-section o-left-box-section--inner c-common-box-shadow">
                            <h5 class="h2 c-font-bold">Employer Request:</h5>
                            <div id="add-call" class="o-file-strip-light word-break">
                                <span v-if="job" v-html="safeJobText(job.employer_requests)"></span>
                            </div>
                            <hr class="o-modal-separetor" />
                            <h5 class="h2 c-font-bold">Comments:</h5>
                            <div id="add-call" class="o-file-strip-light word-break">
                                <span v-if="job" v-html="safeJobText(job.comment)"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-9" v-loading="loading">
                        <div class="skill-assign-holder c-common-gradient c-common-box-shadow" id="skill-assign-holder">
                            <div class="row">
                                <div class="col-sm-12">
                                    <h2 class="h2 text-left o-modal-link c-font-bold"><span id="add-call" @click="navigateToJobDetails" class="header-hyper-link mb-5">{{ job.title }}</span></h2>
                                    <div class="c-common-space o-subtitleHeading text-left">
                                        <label>Group by: </label>
                                        <span>
                                            <div class="checkbox o-custom-radio">
                                                <label>
                                                    Position
                                                    <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.position">
                                                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                </label>
                                            </div>
                                        </span>
                                        <span>
                                            <div class="checkbox o-custom-radio">
                                                <label>
                                                    Start time
                                                    <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.startTime">
                                                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                </label>
                                            </div>
                                        </span>
                                        <span>
                                            <div class="checkbox o-custom-radio">
                                                <label>
                                                    End time
                                                    <input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.endTime">
                                                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                </label>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-12" v-if="modalFilter.position||modalFilter.startTime||modalFilter.endTime">
                                    <hr class="o-modal-separetor">
                                </div>
                                <div class="col-sm-12" v-if="modalFilter.position||modalFilter.startTime||modalFilter.endTime">
                                    <h2 class="h2 text-left o-modal-link c-font-bold">All created calls will have the following values:</h2>
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Start Date:</label>
                                                <el-col :span="50">

                                                <el-date-picker
                                                    name="date"
                                                    class="custom_date"
                                                    v-validate="{ required: true}"
                                                    v-model="addCall[0].date"
                                                    type="date"
                                                    :picker-options="pickerOptions"
                                                    :format="getDisplayFormat()"
                                                    value-format="yyyy-MM-dd"
                                                    :placeholder="getDatePlaceholder()">
                                                </el-date-picker>
                                                </el-col>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" v-if="modalFilter.position">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Position:</label>
                                                <div class="o-cutsomSelect">
                                                    <select v-model="addCall[0].position" @change="getRateAmount(0)" placeholder="Select Position" class="custom_date" name="position" v-validate="{ required: true}">
                                                        <option v-for="(position,index) in positions" :key="index" :value="position.id">
                                                        {{ position.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" v-if="modalFilter.startTime">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Start time:</label>
                                                <div class="o-custom-dropdown">
                                                    <date-picker name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config" :input-attr="{ autocomplete: 'off', readonly: 'readonly' }"></date-picker>
                                                    <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3" v-if="modalFilter.endTime">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">End time</label>
                                                <div class="o-custom-dropdown">
                                                    <date-picker name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config" :input-attr="{ autocomplete: 'off', readonly: 'readonly' }"></date-picker>
                                                    <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12" v-if="modalFilter.position||modalFilter.startTime||modalFilter.endTime">
                                    <hr class="o-modal-separetor">
                                </div>
                                <div class="col-sm-12" v-if="modalFilter.position||modalFilter.startTime||modalFilter.endTime">
                                    <h2 class="h2 text-left o-modal-link c-font-bold">Call groups:</h2>
                                    <div class="table-responsive">
                                        <table class="table o-call-table">
                                            <thead>
                                                <tr>
                                                    <th style="width: 160px; max-width: 160px;" v-if="!modalFilter.position">Position:</th>
                                                    <th style="width: 80px; max-width: 80px;">Quantity:</th>
                                                    <th style="width: 80px; max-width: 80px;">Rate</th>
                                                    <th style="width: 120px; max-width: 1200px;" v-if="!modalFilter.startTime">Start Time</th>
                                                    <th style="width: 120px; max-width: 120px;" v-if="!modalFilter.endTime">End Time</th>
                                                    <th>Notes</th>
                                                    <th style="width: 40px; max-width: 40px;"></th>
                                                </tr>
                                            </thead>
                                            <tbody id="test-body">
                                                <tr v-for="(call,key) in addCall" :key="key">
                                                    <td v-if="!modalFilter.position">
                                                        <div class="o-cutsomSelect">
                                                                <select v-model="call.position" placeholder="Select Position" class="custom_date" name="position" v-validate="{ required: true}" @change="getRateAmount(key)">
                                                                    <option v-for="(position,index) in positions" :key="index" :value="position.id">
                                                                    {{ position.name }}
                                                                    </option>
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" v-model="call.quantity" @input="checkInputQuantity(call.quantity,key)" name="quantity" class="form-control" placeholder="">
                                                    </td>
                                                    <td>
                                                        <input type="number" v-model="call.rate" name="rate" class="form-control" placeholder="">
                                                    </td>
                                                    <td v-if="!modalFilter.startTime">
                                                        <!-- <div class="o-custom-dropdown"> -->
                                                            <date-picker class="o-custom-dropdown" name="start" v-validate="{required: true}" v-model="call.start" :config="config2"  :input-attr="{ autocomplete: 'off', readonly: 'readonly' }"></date-picker>
                                                        <!-- </div> -->
                                                    </td>
                                                    <td v-if="!modalFilter.endTime">
                                                        <!-- <div class="o-custom-dropdown"> -->
                                                            <date-picker class="o-custom-dropdown" name="end" v-validate="{required: true}" v-model="call.end" :config="config2"  :input-attr="{ autocomplete: 'off', readonly: 'readonly' }"></date-picker>
                                                        <!-- </div> -->
                                                    </td>
                                                    <td>
                                                        <textarea v-model="call.notes" class="form-control" rows="2" placeholder="Type your notes"></textarea>
                                                    </td>
                                                    <td class="text-center o-call-icon-allign" v-if="key===addCall.length-1">
                                                        <a href="javascript: void(0)" @click="addNewGroup(call)" class="table-right-icon table-right-icon--plus">
                                                            <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                                        </a>
                                                    </td>
                                                    <td class="text-center o-call-icon-allign" v-else>
                                                        <a href="javascript: void(0)"  @click="removeGroup(key)" class="table-right-icon table-right-icon--minus">
                                                            <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                                        </a>
                                                    </td>                                                
                                                </tr>
                                                <!-- <tr id="">
                                                    <td>
                                                        <div class="o-cutsomSelect">
                                                            <select class="form-control">
                                                                <option>Select 1</option>
                                                                <option>Select 1</option>
                                                                <option>Select 1</option>
                                                                <option>Select 1</option>
                                                                <option>Select 1</option>
                                                                <option>Select 1</option>
                                                                <option>Select 1</option>
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="text" name="quantity" class="form-control" placeholder="">
                                                    </td>
                                                    <td>
                                                        <input type="text" name="rate" class="form-control" placeholder="">
                                                    </td>
                                                    <td>
                                                        <textarea class="form-control" rows="2" placeholder="Type your notes"></textarea>
                                                    </td>
                                                    <td class="text-center o-call-icon-allign">
                                                        <a href="#" class="table-right-icon table-right-icon--plus">
                                                            <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                                        </a>
                                                    </td>
                                                </tr> -->
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-sm-12 text-center mt-5 box-appear" v-if="modalFilter.position||modalFilter.startTime||modalFilter.endTime">
                                    <ul class="o-filter-area margin-top-15">
                                        <li>
                                            <a href="javascript: void(0)" @click="$router.go(-1)" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                        </li>
                                        <li>
                                            <a href="javascript: void(0)" v-bind:disabled="loading" @click="saveBulkCall()" id="btn-add-view" class="c-common-btn c-common-btn--large c-common-btn--green">
                                                <i class="fa fa-plus" aria-hidden="true"></i> Add Calls
                                            </a>
                                        </li>
                                    </ul>

                                    <div id="dummy-div-for-scroll"></div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    
    <div v-else-if="!isEmployeeAllowed">
        <NotAllowed />
    </div>
    <div v-else-if="initialLoading">
        <div class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3" style="margin-left: 10px; margin-top: 80px;">
            <div class="col-md-12 no-job-dispaly">
                <!-- <i class="fa fa-frown-o" aria-hidden="true"></i> -->
                Loading please wait!
            </div>
        </div>
    </div>
      <!-- /Tab nav area -->
  </div>
</template>
<script>
    import { bus } from '../../main';
    import dateTimeConvert from '../../timeConvert&Compare';
    import { mapGetters, mapActions } from 'vuex';
    import service from '../../services.js';
    import { global } from '../../global.js';
    import NotAllowed from '@/components/NotAllowed';
    import * as rt from '../../rateTables';   // #2081

    import safeJobText from '../../safeJobText.js';   // #2005 — v-html on job free text
    export default {
        mixins: [safeJobText],   // #2005 — safeJobText() for the v-html sinks above
        components: {
           NotAllowed
        },
        data() {
            let _vm = this;
            return {
                initialLoading: false,
                isEmployeeAllowed: true,
                job_rate_id: '',
                job_rate_table_id: '',   // #2081 — the job's per-client rate table (flag on only)
                job: null,
                jobStart: null,
                jobEnd: null,

                modalFilter: {
                    position: true,
                    startTime: true,
                    endTime: true
                },

                positions: [],

                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        // Handle case where user inputs 3 or 4 digits (e.g., 800 or 1230)
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                        if (match) {
                            let hours = parseInt(match[1], 10);
                            let minutes = match[2] ? parseInt(match[2], 10) : 0;

                            // Adjust hours if necessary for AM/PM logic (optional)
                            // if (hours > 12) hours -= 12;

                            // Return a Moment.js object
                            return moment({ hour: hours, minute: minutes });
                        }
                        }

                        // Default fallback to create a Moment object
                        return moment(inputDate, 'hh:mm A');
                    }
                },
                config2: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        vertical: 'bottom',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        // Handle case where user inputs 3 or 4 digits (e.g., 800 or 1230)
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                        if (match) {
                            let hours = parseInt(match[1], 10);
                            let minutes = match[2] ? parseInt(match[2], 10) : 0;

                            // Adjust hours if necessary for AM/PM logic (optional)
                            // if (hours > 12) hours -= 12;

                            // Return a Moment.js object
                            return moment({ hour: hours, minute: minutes });
                        }
                        }

                        // Default fallback to create a Moment object
                        return moment(inputDate, 'hh:mm A');
                    }
                    
                },
               
                addCall: [{
                    date: '',
                    start: '',
                    end: '',
                    quantity: '',
                    rate: '',
                    position: '',
                    notes: '',
                    // cookieRole: ''
                }], 
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < _vm.getDatesCallPicker().jobStart || time.getTime() > _vm.getDatesCallPicker().jobEnd);
                    }
                }, 
                getDatesCallPicker: function() {
                    return {
                        jobStart: this.jobStart,
                        jobEnd: this.jobEnd
                    };
                },
                loading: false
            };
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userRoleSlug:'userRoleSlug',
                // job: 'getJob'
            })
        },

        mounted() {
            $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target; // Reference to the picker element
                const currentTime = moment();

                // Check if the input is empty and set the current time in the picker
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
            $(this.$el).find('input').datetimepicker(this.config2)
            .on('dp.show', (e) => {
                const picker = e.target; // Reference to the picker element
                const currentTime = moment();

                // Check if the input is empty and set the current time in the picker
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
        },

        methods: {
            getRateAmount(index) {
                // console.log(index);
                let amount = '';
                let posIndex = -1;
                if(this.modalFilter.position) {
                    posIndex = this.positions.findIndex((obj) =>obj.id == this.addCall[0].position);
                } else if(!this.modalFilter.position) {
                    posIndex = this.positions.findIndex((obj) =>obj.id == this.addCall[index].position);
                }
                let tempPositionSkillRates = [];
                if(posIndex > -1){
                    // #2081 — flag on (the skill carries rate_table_amounts) and the job has a
                    // table: the amount comes from that table, by id. Otherwise master's lookup.
                    if (this.job_rate_table_id && Array.isArray(this.positions[posIndex].rate_table_amounts)) {
                        this.addCall[index].rate = rt.amountFor(this.positions[posIndex], this.job_rate_table_id);
                        return;
                    }
                    tempPositionSkillRates = this.positions[posIndex].skill_rates?this.positions[posIndex].skill_rates: '';
                }
                if(tempPositionSkillRates.length) {
                    // console.log(tempPositionSkillRates);
                    let rateIndex = tempPositionSkillRates.findIndex((obj) =>obj.rate_id == this.job_rate_id);
                    // console.log(rateIndex);
                    amount = rateIndex>-1?tempPositionSkillRates[rateIndex].amount:'';
                    this.addCall[index].rate = amount;
                }else {
                    this.addCall[index].rate = '';
                }
            },
            checkInputQuantity(value,index) {
                let valueDecrease = parseInt(value)
                if(valueDecrease > 100) {
                    this.$notify({
                        type: 'error',
                        message: 'No.of calls must be an integer and below 100',
                        title: 'Not Allowed'
                    });
                    valueDecrease = parseInt(parseInt(value)/10);
                }
                this.addCall[index].quantity = valueDecrease;
            },

            navigateToJobDetails() {
                this.$router.push({
					path:'/jobDetails/'+ this.$route.params.id
				});
            },

            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                    return dateTimeConvert.getDatePlaceHolder();
            },
            onInputchangeCheckbox() {
                this.addCall = [{
                    date: '',
                    start: '',
                    end: '',
                    quantity: '',
                    rate: '',
                    position: '',
                    notes: ''
                }];
                if(this.job) {
                    let jobStartDate = this.job.start.split(" ")
                    let getStartDate = this.$route.query.date?this.$route.query.date : jobStartDate[0];
                    this.addCall[0].date = getStartDate;
                }
            },

            addNewGroup(call) {
                console.log(call);
                var temp = {
                    date: "",
                    position: "",
                    start: '',
                    end: '',
                    quantity: '',
                    rate: '',
                    notes: ''
                };
                // console.log(this.modalFilter.position);               
                this.addCall.push(temp);
                if(this.modalFilter.position) {
                    this.getRateAmount(this.addCall.length-1);
                }
                setTimeout(function(){ 
                    document.getElementById('dummy-div-for-scroll').scrollIntoView({ behavior: 'smooth' });            
                 }, 100);
            },

            // scrollToTarget(target, containerEl) {
            //     console.log("div Block", target);
            //     // Moved up here for readability:
            //     var isElement = target && target.nodeType === 1,
            //         isNumber = Object.prototype.toString.call(target) === '[object Number]';

            //     if (isElement) {
            //         containerEl.scrollTop = target.offsetTop;
            //     } else if (isNumber) {
            //         containerEl.scrollTop = target;
            //     } else if (target === 'bottom') {
            //         containerEl.scrollTop = containerEl.scrollHeight - containerEl.offsetHeight;
            //     } else if (target === 'top') {
            //         containerEl.scrollTop = containerEl.scrollHeight + containerEl.offsetHeight;
            //         console.log(containerEl.scrollTop);
            //     }
            // },

            // scrollToBottom(element) {
            //     console.log(element);
            //     element.scroll({ top: element.scrollHeight, behavior: 'smooth' });
            // },

            // scrollToBottomView() {
            //     console.log("div");
            //     var objDiv = document.getElementById("dummy-div-for-scroll");
            //     objDiv.scroll = objDiv.scrollHeight;
            // },

            removeGroup(key) {
                this.addCall.splice(key, 1);
            },

            getPositions() {  
                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.job ? this.job.client_id : this.userClientID
                }).
                then((res) => {
                    this.positions = res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
            },

            saveBulkCall() {
                this.loading=true;
                this.$forceUpdate();

                this.inputValidation = "";  
                let callData = this.addCall.map(call => {
                    call.date= this.addCall[0].date;

                    if(!this.addCall[0].position && this.modalFilter.position){
                        this.inputValidation = "Please enter the position.";
                    }else if(!call.position && !this.modalFilter.position){
                        this.inputValidation = "Please enter the position.";
                    }
                    
                    else if(!this.addCall[0].start && this.modalFilter.startTime){
                        this.inputValidation = "Please enter the Start Time.";
                    }else if(!call.start && !this.modalFilter.startTime){
                        this.inputValidation = "Please enter the Start Time.";
                    }
                    
                    else if(!this.addCall[0].end && this.modalFilter.endTime){
                        this.inputValidation = "Please enter the End Time.";
                    }else if(!call.end && !this.modalFilter.endTime){
                        this.inputValidation = "Please enter the End Time.";
                    }
                    
                    else if(!call.quantity){
                        this.inputValidation = "Please enter the call group quantity.";
                    } 
                    
                    // else if(!call.rate){
                    //     this.inputValidation = "Please enter rate.";
                    // }             
                    
                    // if(this.inputValidation){
                        // this.$notify({
                        //     title: this.$t('error'),
                        //     message: this.inputValidation,
                        //     type: 'error'
                        // });
                        // return;
                    // }
                    

                    let data = {
                        job_id: this.job.id,
                        quantity: call.quantity,
                        rate: call.rate,
                        skill_id: call.position || this.addCall[0].position,
                        notes: call.notes,
                        start: call.start !== "" ? call.date + " " + dateTimeConvert.convertTo24Hours(call.start) : call.date + " " + dateTimeConvert.convertTo24Hours(this.addCall[0].start),
                        end: call.end !== "" ? call.date + " " + dateTimeConvert.convertTo24Hours(call.end) : call.date + " " + dateTimeConvert.convertTo24Hours(this.addCall[0].end),
                        called_at: call.start !== "" ? call.date + " " + dateTimeConvert.convertTo24Hours(call.start) : call.date + " " + dateTimeConvert.convertTo24Hours(this.addCall[0].start),
                    };

                    if (moment(data.start, 'YYYY-MM-DD HH:mm A').format('YYYY-MM-DD HH:mm:ss').valueOf()>=moment(data.end, 'YYYY-MM-DD HH:mm A').format('YYYY-MM-DD HH:mm:ss').valueOf()) {
                      data.end=moment(data.end, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                    //   console.log("date Increased",data.end);
                    }
                    return data;
                });
                if(this.inputValidation){
                    this.loading=false;
                    this.$notify({
                        title: this.$t('error'),
                        message: this.inputValidation,
                        type: 'error'
                    });
                    document.getElementById('btn-add-view').disabled = false;
                    return;
                }
                callData = JSON.stringify(callData);
                // this.loading = true;
                
                if(this.loading) {
                    service.post('call/storeBulkCall', {
                        'call_array': callData
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.job ? this.job.client_id : this.userClientID
                    })
                    .then((res) => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Call Added Successfully.',
                            type: 'success'
                        });
                        if(this.userRoleSlug == 'employer-admin' || this.userRoleSlug == 'employer') {
                            this.$router.push({ path:  `/viewCallsEmployer/` + this.$route.params.id });
                        }else{
                            this.$router.push({ path:  `/viewCalls/` + this.$route.params.id });
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },

            async jobDetails() {
                this.initialLoading = true;
                this.$Progress.start();
                await service.get('job/' + atob(this.$route.params.id), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then(async (res) => {
                    this.initialLoading = false;
                    //console.log("Job details", res);
                    await this.$store.dispatch('setJob', res.data.result);
                    this.job = res.data.result;
                    this.calls=this.job.calls;
                    this.jobStatus=this.job.status.name;
                    this.notes = res.data.result.notes;
                    this.attachmentList = res.data.result.attachments;
                    this.job_rate_id = res.data.result.rate_id;
                    this.job_rate_table_id = res.data.result.client_rate_table_id ? res.data.result.client_rate_table_id : '';   // #2081
                    this.jobStart = new Date(this.job.start);
                    this.jobStart.setDate(this.jobStart.getDate() - 1);
                    this.jobEnd = new Date(this.job.end);
                    this.$Progress.finish();
					let venue =this.job.venue;
					this.job_delete_notify = this.job.disable_notify;
					if(venue && venue.addresses && venue.addresses.length){
						this.full_address_map =venue.name + ", " +venue.addresses[0].address + ", " +venue.addresses[0].municipality +", "+venue.addresses[0].postcode +", " +venue.addresses[0].state_province +", "+ venue.addresses[0].country;
					}
                }).catch((err) => {
                    this.initialLoading = false;
                    console.log(err);
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });                
            },
            setJobTimeout(time){
                var hours=time.split(':')[0];
                var minutes= time.split(':')[1];
                // console.log(hours/24);
                // console.log(minutes/60);
                // this.jobTimeOut.days=Math.floor(hours/24);
                // this.jobTimeOut.hours=Math.floor(hours%24);
                // this.jobTimeOut.mins=Math.floor(minutes);
            },
        },
        
        async created() {
            await this.jobDetails();
            document.title = `${this.job.job_number}#${this.job.title}`;
            this.getPositions();
            this.onInputchangeCheckbox();
            if(this.job) {
                let jobStartDate = this.job.start.split(" ")
                let getStartDate = this.$route.query.date?this.$route.query.date : jobStartDate[0];
                this.addCall[0].date = getStartDate;
            }
        },
}
</script>

<style scoped>
.box-appear {
    height: 25px;
    width:100%
}
#dummy-div-for-scroll {
    height: 50px;
}
</style>
